import React from 'react';
import { fmtDateTime } from '@/lib/format-date';
import { AuditChangeCell } from './audit-change-cell';

/**
 * Read-only body for the Asset Audit Trail DetailDialog. The generic per-field
 * grid can't render this resource — an audit row's meaningful content is the
 * colored change diff (AuditChangeCell), not a flat set of schema fields — so
 * the config wires this component in via `detailContent`.
 */
function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="mt-0.5 break-words">
        {value == null || value === '' ? <span className="text-muted-foreground">—</span> : value}
      </dd>
    </div>
  );
}

export function AuditDetail({ row }: { row: any }) {
  const asset = [row?.assetFleet, row?.assetRego].filter(Boolean).join(' · ');
  return (
    <div className="space-y-6 text-sm">
      <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
        <Row label="Asset" value={asset} />
        <Row label="Event" value={row?.eventType || row?.operation} />
        <Row label="Who" value={row?.who} />
        <Row label="When" value={row?.createdAt ? fmtDateTime(row.createdAt) : null} />
      </dl>
      <section className="space-y-2">
        <div className="border-b pb-2">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">Details</h3>
        </div>
        <AuditChangeCell row={row} />
      </section>
    </div>
  );
}
